'use client';

import { useEffect } from 'react';
import type { LotteryEventDetail } from '../../types';

// 海外対応用scriptの埋め込み
function WorldShoppingScript({
  lotteryDetail,
  modalScriptSrc,
}: {
  lotteryDetail: LotteryEventDetail;
  modalScriptSrc: string;
}) {
  useEffect(() => {
    if (!lotteryDetail.isGlobal) return;

    const modalScript = document.createElement('script');
    modalScript.type = 'text/javascript';
    modalScript.charset = 'UTF-8'; // 非推奨だが、先方の指示
    modalScript.async = true;
    modalScript.src = modalScriptSrc;
    document.head.appendChild(modalScript);

    const lotteryDetailScript = document.createElement('script');
    lotteryDetailScript.id = 'worldshopping-product-data';
    lotteryDetailScript.type = 'application/json';
    lotteryDetailScript.innerHTML = JSON.stringify({ result: lotteryDetail });
    document.head.appendChild(lotteryDetailScript);

    return () => {
      // 要素が存在する場合のみ削除
      if (lotteryDetailScript.parentNode) {
        lotteryDetailScript.remove();
      }
      if (modalScript.parentNode) {
        modalScript.remove();
      }
    };
  }, [lotteryDetail]);

  return <></>;
}

export default WorldShoppingScript;
